<template>
    <div>
        <select-input
            v-if="inputType === 'select'"
            :name="inputName"
            :options="filterProperties.valueOptions"
            :placeholder="filterProperties.valuePlaceholder"
            :required="true"
            :value="value"
            @input="$emit('input', $event)"
        />
        <text-input
            v-else
            :type="inputType"
            :name="inputName"
            :required="true"
            :value="value"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
    export default {
        props: {
            filterName: {
                type: String,
                required: true,
            },
            inputName: {
                type: String,
                required: true,
            },
            value: {
                type: [String, Number],
                default: '',
            },
            filterProperties: {
                type: Object,
                default: null,
            },
        },

        computed: {
            inputType() {
                if (this.filterProperties) {
                    return this.filterProperties.valueInputType;
                }

                return 'text';
            },
        },

        watch: {
            filterName() {
                this.$emit('input', '');
            },
        },
    };
</script>
